import FatReducedMilkProduct from 'models/FatReducedMilkProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import FatReducedMilkPackage from './FatReducedMilkPackage'

const productOptions = {
  packagingInfo: <FatReducedMilkPackage />,
  productTitle: 'Fat Reduced Milk',
  model: FatReducedMilkProduct,
  validCategories: ['52'],
  validSubCategories: ['002', '004', '006', '012', '014'],
}

const FatReducedMilk = () => <ProductForm product={productOptions} />

export default FatReducedMilk

export const getFatReduceMilkPackage = newProduct => {
  const newFatReduceMilkPackage = {
    UPC: newProduct.UPC,
    MilkType: 'Reduced Fat',
    ReducedFatMilkType: newProduct.ReducedFatMilkType,
    ReducedFatMilkSize: newProduct.ReducedFatMilkSize,
  }
  return newFatReduceMilkPackage
}
export const updateFatReduceMilkPackage = newProduct => {
  const newFatReduceMilkPackage = {
    UPC: newProduct.UPC,
    MilkType: 'Reduced Fat',
    ReducedFatMilkType: newProduct.ReducedFatMilkType,
    ReducedFatMilkSize: newProduct.ReducedFatMilkSize,
  }
  return newFatReduceMilkPackage
}
